var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_5047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_787_5047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000385284H47.9999V48.0002H0V0.000385284Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_787_5047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0093 44.9799C43.085 45.1193 43.2851 45.1193 43.3608 44.9799L46.901 38.4613C46.9733 38.328 46.8769 38.1658 46.7252 38.1658H39.6448C39.4932 38.1658 39.3967 38.328 39.4691 38.4613L43.0093 44.9799Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3086 37.9658C39.3086 38.0762 39.3981 38.1658 39.5086 38.1658H46.8613C46.9718 38.1658 47.0613 38.0762 47.0613 37.9658V14.2922C47.0613 14.1817 46.9718 14.0922 46.8613 14.0922H39.5086C39.3981 14.0922 39.3086 14.1817 39.3086 14.2922V37.9658ZM47.0613 13.8921C47.0613 14.0025 46.9718 14.0921 46.8613 14.0921H39.5086C39.3981 14.0921 39.3086 14.0025 39.3086 13.8921V10.2251C39.3086 10.1146 39.3981 10.0251 39.5086 10.0251H46.8613C46.9718 10.0251 47.0613 10.1146 47.0613 10.2251V13.8921Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0613 10.0254H39.3086V6.76562C39.3086 5.68965 40.1808 4.81741 41.2568 4.81741H45.1131C46.1891 4.81741 47.0613 5.68965 47.0613 6.76562V10.0254Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1855 41.9146V44.9946",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2096 44.3035C34.2096 44.8558 33.7618 45.3035 33.2096 45.3035H3.47203C2.60944 45.3035 1.91016 44.6043 1.91016 43.7416V4.25909C1.91016 3.39649 2.60944 2.69722 3.47203 2.69722H33.2096C33.7618 2.69722 34.2096 3.14493 34.2096 3.69722V44.3035Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 6.6186V41.3818",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 14.8899H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 20.9634H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 27.0371H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 33.1108H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 39.1843H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96802 8.81616H0.9375",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5844 26.6064H11.8555V8.86169H28.5844V26.6064Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 33.8931H28.5845",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 38.2014H28.5845",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_5047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.547cf96af6fab139bdfc8e44675b7109.svg";
export { ForwardRef as ReactComponent };